import { Link } from "react-router-dom";
import { ReactComponent as VehicleIcon } from "assets/collectorIcons/binTruckIcon.svg";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { SourceEnum } from "modules/sourceEnum";

const MapViewTemplate = (props: any): any => {
  const { id, isVehicle, trackerId } = props;
  let linkToMaps: string = "";
  if (isVehicle) {
    linkToMaps = `${RoutePathsEnum.Map}/${SourceEnum.WorkOrders}/${SourceEnum.Vehicle}/${id}`;
  }

  return (
    <div
      className={`d-flex align-items-center col-map-view ${
        isVehicle ? "vehicle" : "provider"
      }`}
    >
      {isVehicle && (
        <>
          <div className="text-align-left no-wrap">
            <VehicleIcon
              data-testid={`collectorIcon_${id}_${
                trackerId ? "with" : "without"
              }_tracker`}
              fill={trackerId ? "green" : "red"}
              stroke="black"
              fillOpacity={1}
            />
            {trackerId && (
              <Link
                data-testid={`collectorMapLink_${id}`}
                className="ps-2 ps-md-3 pe-md-4"
                to={linkToMaps}
              >
                View
              </Link>
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default MapViewTemplate;
